export const SERVICES_DATA = [
  {
    id: "01",
    slug: "wdd-service-s2t",
    name: "Web Design & Development",
    type: "web",
    description: `Seed to Tree offers cutting-edge web design and development services to create dynamic, user-friendly, and responsive websites tailored to your business needs.`,
  },
  //   02
  {
    id: "02",
    slug: "seo-service-s2t",
    name: "Search Engine Optimization (SEO)",
    type: "seo",
    description: `Our expert SEO services ensure your website ranks higher in search engine results, driving organic traffic and boosting your online visibility.`,
  },
  //   03
  {
    id: "03",
    slug: "smm-service-s2t",
    name: "Social Media Marketing & Lead Generation",
    type: "smm",
    description: `Maximize your brand's reach with our targeted social media campaigns, lead generation strategies, and call center marketing services.`,
  },
  //   04
  {
    id: "04",
    slug: "mb-service-s2t",
    name: "Medical Billing Services",
    type: "mb",
    description: `Streamline your healthcare business with our efficient medical billing solutions, ensuring accuracy and timely reimbursements.`,
  },
  //   05
  {
    id: "05",
    slug: "pos-is-service-s2t",
    name: "Point of Sales & Inventory Management Systems",
    type: "pos_ims",
    description: `Our SaaS-based POS and inventory management systems help businesses track sales, manage stock, and reduce inefficiencies with ease.`,
  },
  //   06
  {
    id: "06",
    slug: "web-service-s2t",
    name: "Website Maintenance & Updates",
    type: "web",
    description: `We offer comprehensive SaaS solutions to regularly maintain, update, and enhance your website on a monthly subscription basis.`,
  },
];
